'use strict';
var React = require('react');
var VerticalScrollBar = require('../common/VerticalScrollBar');
var Border = require('../common/Border');
var assetsHelper = require('../../helper/assetsHelper');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');
var _ = require('underscore');

var TitleWindow = React.createClass({

  render: function () {
    var borderProps = {borderWidth: 2, borderVisible: true, borderColor: '#444'};
    var showScrollBar = false;
    var value = styleHelper.getInt(this.props, propConst.VERTICAL_SCROLL_BAR_PROGRESS);

    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var bgColor = styleHelper.getBackgroundColor(this.props);

    var titleStyle = {
      width: w,
      height: this.props.topHeight,
      lineHeight: this.props.topHeight + 'px',
      zIndex: 2
    };
    var contentStyle = {
      top: parseInt(this.props.topHeight, 10),
      width: w,
      height: h - this.props.topHeight - this.props.bottomHeight,
      backgroundColor: bgColor,
      zIndex: 1
    };

    var statusStyle = {
      width: w,
      height: this.props.bottomHeight,
      zIndex: 3
    };
    var labelStyle = {
      height: this.props.topHeight,
      lineHeight: this.props.topHeight + 'px'
    };
    var style = styleHelper.StyleUtil(this.props).size().default({border: '2px solid #444'}).text().background().style;
    showScrollBar = this.props.verticalScrollbarShow;
    return (<div className="component" style={style}>
      <div ref="title" className="title" style={titleStyle}>
        <label style={labelStyle}>
          {styleHelper.getText(this.props)}
        </label>
        <div className="icon-box" style={{height:'auto',right : 6, bottom : (this.props.topHeight - 12)/2 - 6}}>
          {
            this.props.showMin && (
              <img width="12" height="12" className="win-icon"
                   src={assetsHelper.getComponentAsset('window_min')}/>)
          }
          {
            this.props.showMax && (
              <img width="12" height="12" className="win-icon"
                   src={assetsHelper.getComponentAsset('window_max')}/>)
          }
          {
            this.props.showClose && (
              <img width="12" height="12" className="win-icon"
                   src={assetsHelper.getComponentAsset('window_close')}/>)
          }
        </div>
      </div>
      <div ref="content" className="content" style={contentStyle}>
        {
          showScrollBar && (<VerticalScrollBar { ...{
            value: value,
            right: -1,
            height: h - this.props.topHeight - this.props.bottomHeight - 2
          }}/>)
        }
      </div>
      <div ref="bottom" className="status-bar" style={statusStyle}>
        <div className="icon-box">
          {
            this.props.showDrag && (
              <img width="12" height="12" className="win-icon"
                   src={assetsHelper.getComponentAsset('window_drag')}/>)
          }
        </div>
      </div>
    </div>);
  }

});

module.exports = TitleWindow;



/** WEBPACK FOOTER **
 ** ./src/views/Components/TitleWindow.jsx
 **/